import React from "react";
import processBoxStyle from "./processBoxStyle";
import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import _map from "lodash/map";
import { getProcessConfig } from "../../../services/serviceWorldService";
import IconCheckCircleBig from "../../../assets/icons/serviceOverview/IconCheckCircleBig";
import IconProgress from "../../../assets/icons/serviceOverview/IconProgress";
import ContentBox from "../../Box/ContentBox/ContentBox";
import IconWrapper from "../../IconWrapper/IconWrapper";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type InitialProcessBoxProps = {
  productClassName: AbstractCase["name"];
};

//pretty redundant right now, but in the future the content might differ quite a bit
const InitialProcessBox = ({ productClassName }: InitialProcessBoxProps) => {
  const processConfig = getProcessConfig({ name: productClassName, leadStatus: 10, id: 0 });

  if (!processConfig) {
    return null;
  }
  return (
    <ContentBox icon={IconProgress} headline={processConfig.headline} alignContent={"stretch"} loading={false}>
      <Grid container>
        {_map(processConfig.steps, (step, index: number) => (
          <React.Fragment key={index}>
            <Grid size={2}>
              <Stack
                sx={[{
                  alignItems: "center"
                }, processBoxStyle.iconContainer]}>
                {index === 0 ? <Box sx={processBoxStyle.connectorLineInvisible} /> : <Box sx={processBoxStyle.connectorLine} />}
                <Box sx={processBoxStyle.progressIcons}>
                  {step.done ? (
                    <IconCheckCircleBig sx={processBoxStyle.progressIcons} />
                  ) : (
                    <IconWrapper icon={step.icon} alt="Step Icon" sx={processBoxStyle.progressIcons} />
                  )}
                </Box>
                {index === processConfig.steps.length - 1 ? <Box sx={processBoxStyle.connectorLineInvisible} /> : <Box sx={processBoxStyle.connectorLine} />}
              </Stack>
            </Grid>
            <Grid sx={[processBoxStyle.textBlock, step.done ? processBoxStyle.done : null]} size={10}>
              <Grid component={"span"} sx={processBoxStyle.stepHeading}>
                {step.headline}
              </Grid>
              <Typography sx={processBoxStyle.stepText}>{step.content}</Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </ContentBox>
  );
};

export default InitialProcessBox;
